module.exports = __webpack_public_path__ + "static/media/8.d9380b03.png";